const isSeries = tagListCategories =>
  tagListCategories.filter(category => ["series", "episodes", "episode"].indexOf(category.title) > -1).length > 0;

export default isSeries;
